import { normalizeRequiredActions } from '@/utils/access'

function capabilityPolicies (route) {
  const records = route && Array.isArray(route.matched) && route.matched.length ? route.matched : [route]
  return records.map(record => record && record.meta).filter(meta => meta && meta.requiredActions !== undefined)
}

export function routeCapabilityAllowed (route, store) {
  if (route && route.path === '/403') return true
  const policies = capabilityPolicies(route)
  if (!policies.length) return true
  if (!store || !store.getters || !store.getters['access/ready']) return false

  return policies.every(meta => {
    const required = normalizeRequiredActions(meta.requiredActions)
    if (!required.length) return false
    const mode = String(meta.actionMatchMode || 'ALL').toUpperCase()
    if (mode === 'ANY') return store.getters['access/canAny'](required)
    if (mode === 'ALL') return store.getters['access/canAll'](required)
    return false
  })
}

// A server/contract failure closes all dynamic capabilities. A 401 removes the
// cookie through the shared interceptor, and this post-request check keeps the
// guard from continuing with a now-expired credential.
export function bootstrapAccessForNavigation (store, tokenReader) {
  return store.dispatch('access/bootstrap').then(
    () => Promise.resolve().then(() => Boolean(tokenReader())),
    () => Promise.resolve().then(() => Boolean(tokenReader()))
  )
}



// WEBPACK FOOTER //
// ./src/router/access-guard.js